import * as React from "react";
import Component from "../../AbstractComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import Translator from "../../../Translation/Translator";
import { TableComponent } from "../Table/TableComponent";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from "../../Partials/Material/TextField";
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Constants from "../../../Action/Constants";

export default class NewChargesList extends Component {
	protected searchTimer;

	public state = {
		autoFoundCharges: [],
		manuallyFoundCharges: [],
		selectedAutoFoundChargesRows: [],
		selectedManuallyFoundChargesRows: [],
		selectedChargeIds: [],
		showAutoFoundChargesList: false,
		chargeSearchString: "", 
		chargeSearchInProgress: false
	};

  constructor(public props) {
    super(props);
	}

  public componentWillMount() {
    if (this.props.isOpen) {
      this.fetchExistingCharges(true);
    }
  }

	public componentWillUnmount() {
    this.clearTimer();
  }

	public clearTimer = () => {
		clearTimeout(this.searchTimer);
		this.searchTimer = null;
	}

	public switchListView = (): void => {
		this.setState({
			showAutoFoundChargesList: !this.state.showAutoFoundChargesList,
      selectedAutoFoundChargesRows: [],
      selectedManuallyFoundChargesRows: [],
      selectedChargeIds: [],
		})
	}

	public setSearchString = (event): any => {
    this.clearTimer();

    this.setState({
      chargeSearchString: event.target.value
    }, () => {
      if (this.state.chargeSearchString === "") {
        this.clearSearchString();
      }

      this.searchTimer = setTimeout(() => {
        this.updateChargeSearchString(this.state.chargeSearchString);
      }, this.props.app?.listSearchTimeout);
    });
  }

	public clearSearchString = () => {
		this.clearTimer();

    this.setState({
      chargeSearchString: ""
    }, () => {
			this.updateChargeSearchString(this.state.chargeSearchString);
		});
  }

	public onDirectInDirectChargeRowSelection = (_event, rows: number[]): void => {
    let chargesIds: number [];

    chargesIds = rows.map(row => {
      return this.state.autoFoundCharges[row].id;
    });

    // if there are charges selected in the other list first we should clear them
    if (this.state.selectedManuallyFoundChargesRows.length > 0) {
      this.setState({
        selectedManuallyFoundChargesRows: [],
        selectedChargeIds: []
      }, () => {
        // if user click on selected charge
        // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
        if (this.state.selectedAutoFoundChargesRows[0] === rows[0]) {
          this.setState({
            selectedAutoFoundChargesRows: [],
            selectedChargeIds: []
          }, () => {
            if (this.props.isSettleProcess) {
              if (typeof this.props.updateParentState === "function") {
                this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
              }
            }
          });
        } else {
          this.setState({
            selectedAutoFoundChargesRows: rows,
            selectedChargeIds: chargesIds
          }, () => {
            if (this.props.isSettleProcess) {
              if (typeof this.props.updateParentState === "function") {
                this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
              }
            }
          });
        }
      });
    } else {
      if (this.state.selectedAutoFoundChargesRows[0] === rows[0]) {
        this.setState({
          selectedAutoFoundChargesRows: [],
          selectedChargeIds: []
        }, () => {
          if (this.props.isSettleProcess) {
            if (typeof this.props.updateParentState === "function") {
              this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
            }
          }
        });
      } else {
        this.setState({
          selectedAutoFoundChargesRows: rows,
          selectedChargeIds: chargesIds
        }, () => {
          if (this.props.isSettleProcess) {
            if (typeof this.props.updateParentState === "function") {
              this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
            }
          }
        });
      }
    }
  }

  public onObjectChargeRowSelection = (_event, rows: number[]): void => {
    let chargesIds: number [];

    chargesIds = rows.map(row => {
      return this.state.manuallyFoundCharges[row].id;
    });

    // if there are charges selected in the other list first we should clear them
    if (this.state.selectedAutoFoundChargesRows.length > 0) {
      this.setState({
        selectedAutoFoundChargesRows: [],
        selectedChargeIds: []
      }, () => {
        // if user click on selected charge
        // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
        if (this.state.selectedManuallyFoundChargesRows[0] === rows[0]) {
          this.setState({
            selectedManuallyFoundChargesRows: [],
            selectedChargeIds: []
          }, () => {
            if (this.props.isSettleProcess) {
              if (typeof this.props.updateParentState === "function") {
                this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
              }
            }
          });
        } else {
          this.setState({
            selectedManuallyFoundChargesRows: rows,
            selectedChargeIds: chargesIds
          }, () => {
            if (this.props.isSettleProcess) {
              if (typeof this.props.updateParentState === "function") {
                this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
              }
            }
          });
        }
      });
    } else {
      if (this.state.selectedManuallyFoundChargesRows[0] === rows[0]) {
        this.setState({
          selectedManuallyFoundChargesRows: [],
          selectedChargeIds: []
        }, () => {
          if (this.props.isSettleProcess) {
            if (typeof this.props.updateParentState === "function") {
              this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
            }
          }
        });
      } else {
        this.setState({
          selectedManuallyFoundChargesRows: rows,
          selectedChargeIds: chargesIds
        }, () => {
          if (this.props.isSettleProcess) {
            if (typeof this.props.updateParentState === "function") {
              this.props.updateParentState.call(this, {selectedSecondChargeToSettleId: this.state.selectedChargeIds[0]});
            }
          }
        });
      }
    }
  }

  public getCharges = (charges: ChargeInterface[], selectedChargesRows: number[], callback: any): any => {
    return charges
      .map((charge: ChargeInterface, index: number) => {
        if (!charge) {
          return;
        }

        const shouldShowPaidDate = !!charge.oldestPaymentDate;
        const isItemSelected = selectedChargesRows.includes(index);
        const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <TableRow
            hover
            key={`charge-${charge.id}`}
            // onClick={() => {
            //   this.saveDetailsBeforeRedirect(`chargeUpdate-${this.state.charge?.id}-`);

            //   this.redirect(`/app/charge/update/${charge?.id}`);
            // }}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell
              padding="checkbox"
              onClick={event => {event.preventDefault(); event.stopPropagation(); callback(event, [index])}}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell>
            <TableCell style={{width: "24px", paddingLeft: "10px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  style={{color: charge.getIconColor()}}
                  className="icon icon-ic-charge"
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{width: "100px", maxWidth: "100px"}}>
              {
                shouldShowPaidDate && (
                  <div style={{display: "inline-flex", flexDirection: "column"}}>
                    <span>{this.formatter.formatDate(charge.invoiceDate)}</span>
                    {/* <span style={{fontSize: "12px", color: "gray"}}>{`${this.trans("status-paid").toLowerCase()}: ${this.formatter.formatDate(charge.oldestPaymentDate)}`}</span> */}
                  </div>
                )
              }
              {
                !shouldShowPaidDate && (
                  <span>{this.formatter.formatDate(charge.invoiceDate)}</span>
                )
              }
            </TableCell>
            <TableCell>
              <div style={{display: "inline-flex", flexDirection: "column"}}>
                <div style={{display: "flex", justifyContent: "flex-start"}}>
                  {charge?.name || "" }
                  {charge.creationTypeDisplayName && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2px 0px 0px 5px"
                      }}
                    >
                      <div className="list-label creation-type-label">
                        {charge.creationTypeDisplayName}
                      </div>
                    </div>
                  )}
                </div>
                <span style={{fontSize: "12px", color: "gray"}}>
                  {`${charge && charge.description === "" ? this.formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system) + "," +  this.formatter.monthFullFormatDate(charge.firstDate) : charge.description} ${!!charge.relatedEntity ? "- " + charge.relatedEntity.displayName : ""}`}
                </span>
              </div>
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "28%" }}>
              {
                <div style={{display: "inline-flex", flexDirection: "column"}}>
                  <span>{charge.chargeClass.id == ChargeClassContainer.pickIdFromLabel("Payable") && charge?.amount > 0 && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(charge.amount, charge.currency)}</span>
                  {this.renderChargeAmountHint(charge)}
                </div>
              }
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
			return
		}

    if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isPayable){
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-pay")}`
    } else if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isReceivable){
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-receive")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isPayable && !charge.isFullyPaid()){
      status = `${this.trans("status-to-pay")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isReceivable && !charge.isFullyPaid()){
      status = `${this.trans("status-to-receive")}`
    } else if (charge.isFullyPaid() && charge?.isReceivable){
      status = `${this.trans("status-received")}`
    } else if (charge.isFullyPaid() && charge?.isPayable){
      status = `${this.trans("status-amount/paid")}`
    } else {
      status = ""
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {status}
      </span>
    );
  }

  public fetchExistingCharges = (firstAutoSearch = false): void => {
    const chargeClassId =
                          this.props.firstChargeToSettle?.chargeClass?.id == ChargeClassContainer.pickIdFromLabel("Payable") ?
                            ChargeClassContainer.pickIdFromLabel("Receivable") :
                            ChargeClassContainer.pickIdFromLabel("Payable");

    const mainPayload: any = {
      chargeClassId: chargeClassId,
      paid: 0, // unpaid charges
      isAfterStartDate: 1, // do not fetch charges before start date
      toSettleChargeId: this.props.firstChargeToSettle?.id
    };

    // manually search charges for settling
    if (!!this.state.chargeSearchString) {
      this.setState({
        chargeSearchInProgress: true
      }, () => {
        const payload = {
          ...mainPayload,
          filterValue: this.state.chargeSearchString
        };
  
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
          payload: {...payload},
          onSuccess: (data) => {
            const filteredCharges = data.charges.filter(charge => charge.type.id !== TypeContainer.pickIdFromLabel("Settlement"));
  
            this.setState({
              manuallyFoundCharges: filteredCharges,
              chargeSearchInProgress: false
            });
          }
        });
      });
    } else {
      this.setState({
        manuallyFoundCharges: [],
        chargeSearchInProgress: false
      });
    }

    // should find charges for settle with the same counterparty
    if (!!this.props.firstChargeToSettle?.counterparty) {
      const payload = {
        ...mainPayload
      };

      if (this.props.firstChargeToSettle?.contactId) {
        payload.contactId = this.props.firstChargeToSettle?.contactId;
      }
  
      if (this.props.firstChargeToSettle?.companyId) {
        payload.companyId = this.props.firstChargeToSettle?.companyId;
      }

      return this.props.dispatch({
        type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
        payload: {...payload},
        onSuccess: (data) => {
          const filteredCharges = data.charges.filter(charge => charge.type.id !== TypeContainer.pickIdFromLabel("Settlement"));

          this.setState({
            autoFoundCharges: filteredCharges,
						showAutoFoundChargesList: filteredCharges?.length > 0 && firstAutoSearch ? true : false
          });
        }
      })
    }
  }

  public updateChargeSearchString = (chargeSearchString: string) => {
    this.setState({
      chargeSearchString: chargeSearchString
    }, this.fetchExistingCharges);
  }

  public render() {
		const exsistingDirectIndirectChargesAmount: number =
			this.state.autoFoundCharges.map((charge: ChargeInterface, index: number) => {
				if (this.state.selectedAutoFoundChargesRows.includes(index)) {
					const amountUnpaid = charge?.amountRemaining;

					return amountUnpaid;
				}

				return 0;
			}).reduce((a, b) => a + b, 0);

		const exsistingObjectChargesAmount: number =
			this.state.manuallyFoundCharges && this.state.manuallyFoundCharges.map((charge: ChargeInterface, index: number) => {
				if (this.state.selectedManuallyFoundChargesRows.includes(index)) {
					const amountUnpaid = charge?.amountRemaining;

					return amountUnpaid;
				}

				return 0;
			}).reduce((a, b) => a + b, 0);

    return (
			<Card 
				className="card"
				style={{
					marginBottom: "20px"
				}}
			>
				<div style={{padding: "0 0 20px 10px"}}>
					{
						!this.props.isSettleProcess && this.state.autoFoundCharges?.length === 0 && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.trans("page/paymentupdate-hint/paymenthasnotmatchingcharges")}</div>
					}

					{
						!this.props.isSettleProcess && this.state.autoFoundCharges?.length > 0 && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.trans("page/paymentupdate-hint/paymenthasmatchingcharges")}</div>
					}

					{
						this.props.isSettleProcess && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.trans("coach/settlecharge-step/first-info")}</div>
					}

					<div>
						<div>
							{
								this.state.autoFoundCharges && this.state.autoFoundCharges.length > 0 &&
									<div
										style={{display: "flex"}}
									>
										<FormControlLabel
											control={
												<Switch
													checked={this.state.showAutoFoundChargesList}
													onChange={this.switchListView}
													color="primary"
												/>
												}
											label={this.trans("section/charge-tab/existing-switch/listswitcher-label")}
										/>
									</div>
							}

							{
								this.state.showAutoFoundChargesList && (
									<div style={{marginTop: "20px"}}>
										{
											!this.props.hideTotalAmount && this.state.autoFoundCharges && this.state.autoFoundCharges.length > 0 && (
												<div
													style={{
														padding: "0 24px 15px 0",
														fontSize: "14px",
														display: "flex",
														justifyContent: "flex-end",
														textAlign: "center"
													}}
												>
													{Translator.transJSX("total-amount", {
														amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(exsistingDirectIndirectChargesAmount, this.props.app?.settings?.user?.currency)}</span>
													})}
												</div>
											)
										}
										
										<TableComponent
											{...this.props}
											paginator={{
												name: "ExsistingDirectIndirectChargesList",
												path: this.props.app.paginator
											}}
											className="listing-table new-payment-charges-table"
											rows={this.getCharges(this.state.autoFoundCharges,
																						this.state.selectedAutoFoundChargesRows,
																						this.onDirectInDirectChargeRowSelection)
														}
										/>
										{this.state.autoFoundCharges?.length === 0 && (
											<div style={{padding: "0 25px 0 0", color: "gray"}}>{this.trans("section/charge-tab/existing-info/chargesnotfound")}</div>
										)}
									</div>
								)
							}

							{
								!this.state.showAutoFoundChargesList && (
									<div>
										<div className="list-filterer">
											<TextField
												className="form-element full-size"
												autoComplete="off"
												type="text"
												style={{color: "rgb(0, 188, 212)"}}
												label={this.trans("label/searchcharge")}
												value={this.state.chargeSearchString}
												onChange={this.setSearchString}
												variant="standard"
												error={false}
											/>
											{ 
												this.state.chargeSearchString !== "" &&
												<div className="icon icon-ic-close clear-button clear-button-search" onClick={this.clearSearchString}></div>
											}
											{ 
												this.state.chargeSearchInProgress &&
												<div className="search-loader">
													<CircularProgress size={20} />
												</div>
											}
										</div>

										<div style={{marginTop: "20px"}}>
											{
												!this.props.hideTotalAmount && this.state.manuallyFoundCharges && this.state.manuallyFoundCharges.length > 0 && (
													<div
														style={{
															padding: "0 24px 15px 0",
															fontSize: "14px",
															display: "flex",
															justifyContent: "flex-end",
															textAlign: "center"
														}}
													>
														{Translator.transJSX("total-amount", {
															amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(exsistingObjectChargesAmount, this.props.app?.settings?.user?.currency)}</span>
														})}
													</div>
												)
											}
											<TableComponent
												{...this.props}
												paginator={{
													name: "ExsistingObjectChargesList",
													path: this.props.app.paginator
												}}
												dispatch={this.props.dispatch}
												className="listing-table new-payment-charges-table"
												rows={this.getCharges(this.state.manuallyFoundCharges, this.state.selectedManuallyFoundChargesRows, this.onObjectChargeRowSelection)}
											/>
											{this.searchTimer && this.state.chargeSearchString && !this.state.chargeSearchInProgress && this.state.manuallyFoundCharges?.length === 0 && (
												<div style={{padding: "0 25px 0 0", color: "gray"}}>{this.trans("section/charge-tab/existing-info/chargesnotfound")}</div>
											)}
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>
			</Card>
    );
  }
}
